import { render, staticRenderFns } from "./FormResultList.vue?vue&type=template&id=6685740a&"
import script from "./FormResultList.vue?vue&type=script&lang=js&"
export * from "./FormResultList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports